import axios from "axios";

export default axios.create({
   baseURL:"https://api.sygenecole.com/",
 //baseURL:"http://localhost:8000",  
//baseURL:"http://192.168.228.120:8000",
  withCredentials:true,
   headers: { 'X-Requested-With': 'XMLHttpRequest' }
})
